const CookiePolicyEN = () => {
	return (
		<div>
			<div className="mt-10 text-gray-800">
				<h2 className="text-1xl font-bold mb-4">Cookie Policy</h2>
				<p className="text-sm text-gray-600">Effective Date: 01.04.2025</p>
				<p className="mt-2">
					At <strong>Agronnect LLC</strong> (“we,” “our,” or “us”), we are committed to protecting
					and respecting your privacy. This Cookie Policy explains how we use cookies and similar
					tracking technologies on our website{' '}
					<a
						href="http://telagri.com"
						target="_blank"
						className="text-blue underline"
						style={{ display: 'inline-flex' }}
					>
						{' '}
						telagri.com
						<svg
							width="16"
							height="16"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g id="Interface / External_Link">
								<path
									id="Vector"
									d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11"
									stroke="#1b73e8"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</g>
						</svg>
					</a>{' '}
					(the “Site”)
				</p>
				<p className="mt-2">
					By using our Site, you agree to the use of cookies as described in this policy. If you do
					not agree with our use of cookies, you can adjust your browser settings or take other
					steps outlined below to control your cookie preferences.
				</p>

				<h3 className="mt-4 text-lg font-semibold">1. What are cookies?</h3>
				<p className="mt-2">
					Cookies are small text files that are stored on your device (computer, smartphone, tablet)
					when you visit a website. They are commonly used to improve the functionality of websites,
					provide a better user experience, and gather data for analytical purposes.
				</p>

				<h3 className="mt-4 text-lg font-semibold">2. Types of cookies we use</h3>
				<ul className="list-disc ml-5 mt-2">
					<li>
						<strong>Essential Cookies</strong>: These cookies are necessary for the operation of our
						Site. They enable basic functions like page navigation, secure areas, and user
						authentication. Without these cookies, certain features of the Site may not work.
					</li>
					<li>
						<strong>Performance Cookies</strong>: These cookies collect information about how
						visitors use our Site (e.g., which pages they visit most frequently and if they
						encounter any error messages). These cookies do not collect personal data and are used
						solely to improve the performance and functionality of the Site.
					</li>
					<li>
						<strong>Functional Cookies</strong>: These cookies allow our Site to remember your
						preferences (such as language or region) and provide enhanced, more personalized
						features. They may also be used to remember your login details, so you don't have to
						re-enter them each time you visit.
					</li>
					<li>
						<strong>Targeting/Advertising Cookies</strong>: These cookies are used to deliver
						relevant advertisements to you based on your interests. They may track your browsing
						habits across different websites to build a profile of your interests and serve
						personalized ads.
					</li>
					<li>
						<strong>Analytics Cookies</strong>: These cookies help us analyze how visitors interact
						with our Site. They provide information about the number of visitors, the pages viewed,
						and the overall performance of the Site. We use this data to improve our Site and
						services.
					</li>
				</ul>

				<h3 className="mt-4 text-lg font-semibold">3. How we use cookies</h3>
				<p className="mt-2">We use cookies for the following purposes:</p>
				<ul className="list-disc ml-5">
					<li>To enhance your experience on our Site by remembering your preferences.</li>
					<li>
						To understand how you use our Site, so we can improve its content and functionality.
					</li>
					<li>To personalize content and advertisements based on your browsing habits.</li>
					<li>To track the effectiveness of our marketing efforts.</li>
				</ul>

				<h3 className="mt-4 text-lg font-semibold">4. Third-Party Cookies</h3>
				<p className="mt-2">
					In addition to our own cookies, we may allow third-party service providers (such as
					analytics or advertising partners) to place cookies on your device. These third parties
					may use cookies to collect information about your online activities across different
					websites and services to deliver more relevant ads or to analyze website traffic.
				</p>

				<h3 className="mt-4 text-lg font-semibold">5. Managing and Controlling Cookies</h3>
				<p className="mt-2">
					You have the option to control the use of cookies on our Site. You can manage your cookie
					preferences through the following methods:
				</p>
				<ul className="list-disc ml-5">
					<li>
						<strong>Browser Settings</strong>: Most web browsers allow you to control cookies
						through their settings. You can block cookies, delete existing cookies, or set your
						browser to notify you when cookies are being placed on your device. Please refer to your
						browser's help section for detailed instructions.
					</li>
					<li>
						<strong>Cookie Consent Management Tool</strong>: Our Site provides a cookie consent
						banner when you first visit. You can change your preferences at any time by clicking on
						the "Cookie Settings" link at the bottom of our Site.
					</li>
				</ul>
				<p className="mt-2">
					Please note that blocking or deleting cookies may affect the functionality of some
					features on our Site.
				</p>

				<h3 className="mt-4 text-lg font-semibold">6. Data Retention</h3>
				<p className="mt-2">
					Cookies set by our Site are typically stored for a period of up to 1 year, after which
					they are automatically deleted or expire. Third-party cookies may have different retention
					periods, which you can learn more about by reviewing their respective privacy policies.
				</p>

				<h3 className="mt-4 text-lg font-semibold">7. Changes to this Cookie Policy</h3>
				<p className="mt-2">
					We may update this Cookie Policy from time to time to reflect changes in our practices or
					for other operational, legal, or regulatory reasons. When we make changes to this policy,
					we will update the "Effective Date" at the top of the page. We encourage you to review
					this Cookie Policy periodically to stay informed about how we use cookies.
				</p>

				<h3 className="mt-4 text-lg font-semibold">8. Contact Us</h3>
				<p className="mt-2">
					If you have any questions about this Cookie Policy or our use of cookies, please contact
					us at:
				</p>
				<ul className="list-disc ml-5">
					<li>
						Email:{' '}
						<a href="mailto:info@telagri.com" className="text-blue underline">
							info@telagri.com
						</a>
					</li>
					<li>
						Phone:{' '}
						<a className="text-blue underline" href="tel:+995555655111">
							+995555655111
						</a>
					</li>
					<li>Postal Address: 54 Ketevan Tsamebuli Ave., Tbilisi, Saburtalo 0177, Georgia</li>
				</ul>
			</div>
		</div>
	);
};

const CookiePolicyGE = () => {
	return (
		<div>
			<h1 className="text-lg font-bold mb-4 mt-10">ქუქი-ფაილების გამოყენების წესები</h1>
			<p className="mb-4">ძალაში შესვლის თარიღი: 01.04.2025</p>
			<p className="mb-4">
				შპს აგრონექტში ("ჩვენი" ან "ჩვენ"), ჩვენ ვალდებულნი ვართ დავიცვათ და პატივი ვცეთ თქვენს
				კონფიდენციალურობას. ეს ქუქი-ფაილების გამოყენების წესები („წესები“) განმარტავს, თუ როგორ
				ვიყენებთ ქუქი-ფაილებს და მსგავს მონიტორინგის ტექნოლოგიებს ჩვენს ვებ-გვერდზე{' '}
				<a
					href="http://telagri.com"
					target="_blank"
					className="text-blue hover:underline"
					style={{ display: 'inline-flex' }}
				>
					telagri.com
					<svg
						width="16"
						height="16"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g id="Interface / External_Link">
							<path
								id="Vector"
								d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11"
								stroke="#1b73e8"
								stroke-width="2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</g>
					</svg>
				</a>{' '}
				(„საიტი“).
			</p>
			<p className="mb-4">
				ჩვენი საიტის გამოყენებით, თქვენ ეთანხმებით ქუქი-ფაილების გამოყენებას, როგორც ეს აღწერილია ამ
				წესებში. თუ არ ეთანხმებით ჩვენს მიერ ქუქი-ფაილების გამოყენების წესებს, შეგიძლიათ შეცვალოთ
				თქვენი ბრაუზერის პარამეტრები ან გადადგათ ქვემოთ ჩამოთვლილი სხვა ნაბიჯები თქვენი
				ქუქი-ფაილების პარამეტრების გასაკონტროლებლად.
			</p>

			<h2 className="text-lg font-semibold mt-6 mb-2">1. რა არის ქუქი-ფაილები?</h2>
			<p className="mb-4">
				ქუქი-ფაილები არის მცირე ზომის ტექსტური ფაილები, რომლებიც ინახება თქვენს მოწყობილობაზე
				(კომპიუტერი, სმარტფონი, ტაბლეტი) ვებსაიტზე სტუმრობისას. ისინი ჩვეულებრივ გამოიყენება
				ვებსაიტების ფუნქციონირების გასაუმჯობესებლად, მომხმარებლის უკეთესი გამოცდილების
				უზრუნველსაყოფად და ანალიტიკური მიზნებისთვის მონაცემების შესაგროვებლად.
			</p>

			<h2 className="text-lg font-semibold mt-6 mb-2">
				2. ჩვენს მიერ გამოყენებული ქუქი-ფაილების ტიპები
			</h2>
			<ul className="list-disc pl-6 mb-4">
				<li>
					<strong>აუცილებელი ქუქი-ფაილები:</strong> ეს ქუქი-ფაილები აუცილებელია ჩვენი საიტის
					ფუნქციონირებისთვის.
				</li>
				<li>
					<strong>სამუშაო ქუქი-ფაილები:</strong> ეს ქუქი-ფაილები აგროვებენ ინფორმაციას იმის შესახებ,
					თუ როგორ იყენებენ მომხმარებლები ჩვენს საიტს.
				</li>
				<li>
					<strong>ფუნქციური ქუქი-ფაილები:</strong> ეს ქუქი-ფაილები საშუალებას აძლევენ ჩვენს საიტს
					დაიმახსოვროს თქვენი არჩეული პარამეტრები.
				</li>
				<li>
					<strong>მიზნობრივი/სარეკლამო ქუქი-ფაილები:</strong> გამოიყენება თქვენთვის შესაბამისი
					რეკლამის მოსაწოდებლად.
				</li>
				<li>
					<strong>ანალიტიკის ქუქი-ფაილები:</strong> ეს ქუქი-ფაილები გვეხმარება გავაანალიზოთ, როგორ
					ურთიერთობენ მომხმარებლები ჩვენს საიტთან.
				</li>
			</ul>

			<h2 className="text-lg font-semibold mt-6 mb-2">3. როგორ ვიყენებთ ქუქი-ფაილებს</h2>
			<p className="mb-4">
				ჩვენ ვიყენებთ ქუქი-ფაილებს შემდეგი მიზნებისთვის: უკეთესი მომხმარებლის გამოცდილების
				უზრუნველსაყოფად, მარკეტინგული სვლების ეფექტურობის თვალყურის მისადევნებლად და საიტის
				გაუმჯობესებისთვის.
			</p>

			<h2 className="text-lg font-semibold mt-6 mb-2">4. მესამე მხარის ქუქი-ფაილები</h2>
			<p className="mb-4">
				ჩვენი საკუთარი ქუქი-ფაილების გარდა, ჩვენ შეიძლება უფლება მივცეთ მესამე მხარის სერვისის
				პროვაიდერებს (როგორიცაა ანალიტიკა ან სარეკლამო პარტნიორები) განათავსონ ქუქი-ფაილები თქვენს
				მოწყობილობაზე.
			</p>

			<h2 className="text-lg font-semibold mt-6 mb-2">5. ქუქი-ფაილების მართვა და კონტროლი</h2>
			<p className="mb-4">
				თქვენ შეგიძლიათ აკონტროლოთ ქუქი-ფაილების გამოყენება თქვენი ბრაუზერის პარამეტრების ან
				ქუქი-ფაილების თანხმობის მართვის ხელსაწყოს გამოყენებით.
			</p>

			<h2 className="text-lg font-semibold mt-6 mb-2">6. ინფორმაციის შენახვის ვადა</h2>
			<p className="mb-4">
				ჩვეულებრივ, ჩვენი საიტის მიერ დაყენებული ქუქი-ფაილები ინახება 1 წლამდე ვადით, რის შემდეგაც
				ისინი ავტომატურად იშლება ან ვადა ეწურება.
			</p>

			<h2 className="text-lg font-semibold mt-6 mb-2">
				7. ცვლილებები ამ ქუქი-ფაილების გამოყენების წესებში
			</h2>
			<p className="mb-4">
				ჩვენ შესაძლოა დროდადრო განვაახლოთ ქუქი-ფაილების პოლიტიკა. როდესაც ამ პოლიტიკაში ცვლილებებს
				შევიტანთ, განვაახლებთ "ძალაში შესვლის თარიღს".
			</p>

			<h2 className="text-lg font-semibold mt-6 mb-2">8. კონტაქტი</h2>
			<p className="mb-4">თუ გაქვთ რაიმე შეკითხვა, გთხოვთ დაგვიკავშირდეთ შემდეგ მისამართზე:</p>
			<ul className="list-disc pl-6 mb-4">
				<li>
					<strong>ელ.ფოსტა:</strong>{' '}
					<a href="mailto:info@telagri.com" className="text-blue underline">
						info@telagri.com
					</a>
				</li>
				<li>
					<strong>ტელეფონი:</strong>{' '}
					<a className="text-blue underline" href="tel:+995555655111">
						+995555655111
					</a>
				</li>
				<li>
					<strong>საფოსტო მისამართი:</strong> ქეთევან წამებულის გამზ., #54 თბილისი, საბურთალო 0177,
					საქართველო
				</li>
			</ul>
		</div>
	);
};

import { TelagriLogo } from '@assets/icons/TelagriLogo';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { usePageTitle } from '@hooks/usePageTitle';
import { useTranslation } from 'react-i18next';
// In future, we need to add textes in json files and import them here, instead of having two seperate component for translations. This is just quick solution.
export default function CookiePolicy() {
	const { i18n } = useTranslation();
	const { navigateWithLanguage } = useLanguageNavigate();
	const { t } = useTranslation();

	usePageTitle(t('cookiePolicy'));
	const CookiesComponent = i18n.language === 'en' ? <CookiePolicyEN /> : <CookiePolicyGE />;

	return (
		<div className="mx-auto p-6 bg-white shadow-lg rounded-2xl">
			<div className="flex justify-center items-center">
				<div
					className="w-[200px] h-[61px] max-sm:w-[150px] max-sm:h-[45px]"
					onClick={() => navigateWithLanguage('/login')}
				>
					<TelagriLogo />
				</div>
			</div>
			{CookiesComponent}
		</div>
	);
}
